import { initReactI18next } from 'react-i18next'

import en from './en'
import jp from './jp'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { enums } from 'utils/constants'

const resources = {
  en: {
    translation: en,
  },
  jp: {
    translation: jp,
  },
}

const language = enums.LANGUAGE.JAPAN

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    compatibilityJSON: 'v3',
    resources,
    lng: language,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  })

export default i18n
